import styled from 'styled-components';

export const StyledDiv = styled.div`
  padding-top: 35px;
  padding-bottom: 24px;
  border-bottom: 1px solid var(--beam-color-neutral-n300);

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FilterSection = styled.div`
  display: grid;
  column-gap: 8px;
  grid-template-columns: minmax(auto, 250px) repeat(2, min-content);
`;
